module.exports = __webpack_public_path__ + "static/media/bell-o.28b82675.svg";